import { Directive, Renderer2, AfterViewInit, OnDestroy, inject } from '@angular/core';

@Directive({
  selector: '[coreLinkClass]',
  standalone: false,
})
export class LinkClassDirective implements AfterViewInit, OnDestroy {
  private renderer = inject(Renderer2);

  private observer: MutationObserver | null = null;

  ngAfterViewInit() {
    // Process existing links
    this.processLinks();

    // Set up a MutationObserver to watch for changes to the DOM
    this.observer = new MutationObserver(mutations => {
      // Check if any new links have been added
      const newLinks = mutations.some(mutation =>
        Array.from(mutation.addedNodes).some(
          node =>
            node.nodeType === Node.ELEMENT_NODE &&
            (node.nodeName === 'A' || (node as Element).querySelectorAll('a').length > 0),
        ),
      );

      if (newLinks) {
        this.processLinks();
      }
    });

    // Start observing the document body
    this.observer.observe(document.body, {
      childList: true,
      subtree: true,
    });
  }

  ngOnDestroy() {
    // Clean up the observer when the directive is destroyed
    if (this.observer) {
      this.observer.disconnect();
      this.observer = null;
    }
  }

  private processLinks() {
    // Look for links in the entire document
    const links = document.querySelectorAll('a');
    if (links.length !== 0) {
      links.forEach((link: HTMLAnchorElement) => {
        const href = link.getAttribute('href');
        if (href) {
          if (href.endsWith('.pdf')) {
            this.renderer.addClass(link, 'doc');
          } else if (href.startsWith('mailto')) {
            this.renderer.addClass(link, 'mail');
          } else if (href.startsWith('http') && !href.includes(window.location.hostname)) {
            this.renderer.addClass(link, 'external');
          } else {
            this.renderer.addClass(link, 'internal');
          }
        }
      });
    }
  }
}
